import { cn } from "utils";
import { ColorDot } from "../ColorDot";

export interface MarketLegendItem {
  key: string;
  label: string;
  colorClassName?: string;
  color?: string;
}

export interface MarketLegendProps {
  items: MarketLegendItem[];
  className?: string;
  "aria-label"?: string;
}

export const MarketLegend = ({
  items,
  className,
  "aria-label": ariaLabel,
}: MarketLegendProps) => (
  <ul
    aria-label={ariaLabel}
    className={cn("flex items-center gap-4", className)}
  >
    {items.map((item) => (
      <li
        key={item.key}
        className="flex items-center gap-1.5 text-xs text-muted-foreground"
      >
        <ColorDot
          className={cn("h-3 w-3", item.colorClassName)}
          style={
            !item.colorClassName && item.color
              ? { backgroundColor: item.color }
              : undefined
          }
        />
        {item.label}
      </li>
    ))}
  </ul>
);
